import React, { useEffect, useState } from "react";
import InstructionBox from "../InstructionBox";
import useTailwindBreakpoints from "../../../../hooks/useTailwindBreakPoints";
import { useTheme } from "../../../../theme/ThemeProvider";

export type IInstructionsProps = {
  challengeType: string;
};

const InstructionsViewer: React.FC<IInstructionsProps> = ({
  challengeType,
}) => {
  const { lg } = useTailwindBreakpoints();

  const [currentIndex, setCurrentIndex] = useState(0);
  const { theme } = useTheme();
  const smsImages = [`${theme}-step1-sms.svg`, `${theme}-step2-sms.svg`];

  useEffect(() => {
    const interval = setInterval(() => {
      if (challengeType === "SMS") {
        setCurrentIndex((prevIndex: any) => (prevIndex + 1) % smsImages.length);
      } else {
        setCurrentIndex(
          (prevIndex: any) => (prevIndex + 1) % manualImages.length
        );
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [smsImages.length]); // eslint-disable-line react-hooks/exhaustive-deps

  const isHighRisk =
    challengeType === "ST_HIGHRISK_TOTP" ||
    challengeType === "ST_HIGHRISK_STOTP";
  const isLowRisk =
    challengeType === "ST_LOWRISK_TOTP" || challengeType === "ST_LOWRISK_STOTP";

  const imageProvider = () => {
    if (isHighRisk) {
      return `${theme}_manual_step2_hr.svg`;
    }
    if (isLowRisk) {
      return `${theme}_manual_step2.svg`;
    }
    return "step2.svg";
  };
  const manualImages = [
    `${theme}_manual_step1.svg`,
    imageProvider(),
    `${theme}_manual_step3.svg`,
  ];

  if (challengeType === "SMS") {
    if (!lg) {
      return (
        <div className="flex flex-row justify-center gap-11 z-10">
          <InstructionBox
            id="1"
            img={smsImages[currentIndex]}
            className="animate-slideRight1 initial-hidden"
          />
        </div>
      );
    } else
      return (
        <div className="flex flex-row w-[803px] justify-center gap-11 z-10">
          <InstructionBox
            id="1"
            img={`${theme}-step1-sms.svg`}
            className="animate-slideRight1 initial-hidden"
          />{" "}
          <InstructionBox
            id="1"
            img={`${theme}-step2-sms.svg`}
            className="animate-slideRight2 initial-hidden"
          />
        </div>
      );
  } else {
    if (!lg) {
      return (
        <div className="flex flex-row justify-center gap-11 z-10">
          <InstructionBox
            id="1"
            img={manualImages[currentIndex]}
            className="animate-slideRight1 initial-hidden"
          />
        </div>
      );
    } else {
      return (
        <div className="flex flex-row w-[803px] justify-between z-10">
          <InstructionBox
            id="1"
            img={`${theme}_manual_step1.svg`}
            className="animate-slideRight1 initial-hidden"
          />
          <InstructionBox
            id="2"
            img={imageProvider()}
            className="animate-slideRight2 initial-hidden "
          />
          <InstructionBox
            id="3"
            img={`${theme}_manual_step3.svg`}
            className="animate-slideRight3 initial-hidden"
          />
        </div>
      );
    }
  }
};

export default InstructionsViewer;
